import * as React from 'react';
import { EMPTY_TEXT, Magnetic, MenuListItem, WhiteLabelMobileSpeechBox } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { PhotoCapture } from '../enums';
import { PhotoCaptureConstants } from '../constants';
import { usePhotoCaptureBasicWorker } from '../hooks';
import { getNavigationMultipleButtonProps } from '../utilities';
import { IntelligentPBEContainerComponent } from './intelligentComponents';
import { StyledActionControlsSection, StyledContent, StyledMenuItem } from './SinglePhotoUploadComponent.style';
import { StyledDivAvatarSpechBoxLayout } from './intelligentComponents/IntelligentScriptQuestion.style';
export const ChoiceSelectionComponent = ({ appTheme, questionText, isSaveSuccess, companyCode, evaluationDocId, questionnaireId, questionnaireQuestionId, questionSubType, contextId, isContextUpdated, isTermsAndConditionAccepted, parentQuestionId, answerList = [], isMultiSelectionAllowed, photoCaptureAttachmentInfo, attachedArtifactIds, warningMessage, isMic, photoCaptureUpdateAttachmentDataSuccessAction, photoCaptureUpdateAttachedArtifactIdSuccessAction, photoCaptureUpdateContextDataAction, questionnaireEvaluationQuestionGetAction, questionnaireEvaluationSaveRequestAction, photoCaptureResetContextAction }) => {
    var _a;
    const [choiceList, setChoiceList] = React.useState(answerList);
    const translateFn = TranslationService.translate;
    const { movePrevious, moveNext } = usePhotoCaptureBasicWorker({
        appTheme,
        questionText,
        isSaveSuccess,
        companyCode,
        evaluationDocId,
        questionnaireId,
        questionnaireQuestionId,
        questionSubType,
        contextId,
        isContextUpdated,
        isTermsAndConditionAccepted,
        parentQuestionId,
        photoCaptureAttachmentInfo,
        answerList,
        attachedArtifactIds,
        photoCaptureUpdateAttachmentDataSuccessAction,
        photoCaptureUpdateAttachedArtifactIdSuccessAction,
        photoCaptureUpdateContextDataAction,
        questionnaireEvaluationQuestionGetAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureResetContextAction
    });
    React.useEffect(() => {
        setChoiceList(answerList);
    }, [JSON.stringify(answerList)]);
    const onChoiceSelection = (answerText) => {
        if (!isMultiSelectionAllowed) {
            answerText && moveNext(answerText);
        }
        else {
            const answerStateList = choiceList.map((item) => {
                if (item.defaultAnswerDisplayText === answerText) {
                    item.answered = !item.answered;
                }
                return item;
            });
            setChoiceList(answerStateList);
        }
    };
    const handleNextClick = () => {
        const multiSelectedChoice = choiceList
            .filter(item => item.answered)
            .map((item) => {
            return {
                complexAnswerTxt: item.defaultAnswerDisplayText || '',
                additionalAnswerInfo: ''
            };
        });
        moveNext(multiSelectedChoice);
    };
    const shouldShowNextButtonDisabled = !((_a = choiceList.find((item) => item.answered)) === null || _a === void 0 ? void 0 : _a.answered) || false;
    const getMultipleButtonConfig = () => {
        if (isMultiSelectionAllowed && !isMic) {
            return {
                multipleButtonProps: Object.assign(Object.assign({}, getNavigationMultipleButtonProps({
                    appTheme: appTheme,
                    onLeftClick: movePrevious,
                    onRightClick: handleNextClick
                })), { rightButtonLabel: PhotoCaptureConstants.NEXT, leftButtonLabel: PhotoCaptureConstants.PREVIOUS, leftButtonIcon: EMPTY_TEXT, shouldNextButtonDisabled: shouldShowNextButtonDisabled, isLeftBtnSelected: false })
            };
        }
        return {};
    };
    const shouldShowFooter = (isMultiSelectionAllowed && isMic) || (!isMultiSelectionAllowed && !isMic);
    const handleMove = () => {
        if (isMic) {
            handleNextClick();
        }
        else {
            movePrevious();
        }
    };
    return (React.createElement(IntelligentPBEContainerComponent, Object.assign({ islanguageHide: true, appTheme: appTheme, isDeviceLibDisabled: false, warningMessage: warningMessage, hasMultipleButton: isMultiSelectionAllowed && !isMic, isFooter: shouldShowFooter }, getMultipleButtonConfig(), { btnLabel: translateFn(isMic ? PhotoCaptureConstants.NEXT : PhotoCaptureConstants.PREVIOUS), isBtnDisabled: isMic ? shouldShowNextButtonDisabled : false, shouldAllowMitchellIntelligent: isMic, moveNext: handleMove, movePrevious: movePrevious }),
        React.createElement(StyledContent, null,
            React.createElement(StyledDivAvatarSpechBoxLayout, null,
                React.createElement(WhiteLabelMobileSpeechBox, { speechBoxRichText: questionText, speechBoxBackgroundColor: appTheme.speechBoxBackgroundColor })),
            React.createElement(StyledActionControlsSection, null, choiceList &&
                choiceList.map((item, index) => {
                    return (React.createElement(StyledMenuItem, { key: index },
                        React.createElement(MenuListItem, { idPrefix: `${PhotoCapture.PHOTO_CAPTURE}_menuItem`, key: item.answerItemID, description: item.answerDisplayText || EMPTY_TEXT, id: item.defaultAnswerDisplayText || EMPTY_TEXT, isItemSelected: item.answered, onItemClicked: () => onChoiceSelection(item.defaultAnswerDisplayText), isPrefixIconVisible: false, backgroundColor: Magnetic.colorWhite, selectedBackgroundColor: appTheme.selectedButtonBackgroundColor })));
                })))));
};
//# sourceMappingURL=ChoiceSelectionComponent.js.map